import { z } from "zod";

import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";

export const priceCategoryFormSchema = z.object({
  name: z
    .string()
    .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
  type: z
    .string()
    .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
  commissionRate: z.number().min(0).max(500),
  defaultPrice: z.number(),
});

export type PriceCategoryFormData = z.infer<typeof priceCategoryFormSchema>;
